import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MetadataState } from '../../types';

const initialState: MetadataState = {
  isLoading: true,
  language: 'de',
};

const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
  },
});

export const { setIsLoading, setLanguage } = metadataSlice.actions;
export default metadataSlice.reducer;
